import React, { Component } from "react";
import "../styling/App.css";
import styled from "styled-components";
import iconClock from "../images/icon-clock.png";
import iconInvoice from "../images/icon-invoice.png";
import pdf from "../assets/erlaeuterungstext_haufe_einsparpotenzial.pdf";

let Footer = styled.div`
  transition-property: top;
  transition-duration: 1s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  bottom: 20%;
  z-index: 999;
  animation-duration: 2s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: running;
  flex: 1;
`;

const FooterContainer = styled.div``;

let ResultBox = styled.div`
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ResultMini = styled.div`
  flex: 1;
  padding: 0 32px;
  margin: 46px 0;
  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;
const WhiteContainer = styled.div`
  padding: 1rem 0rem; ;
`;

const WhiteContainerInner = styled.div`
  padding: 0 15%;
  margin-left: auto;
  margin-right: auto;
  min-height: 570px; /* not a nice solution to make both containers equal height, a fast one though */
  background-color: white;
  padding: 28px 20px;
  -webkit-box-shadow: -3px 2px 12px -6px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -3px 2px 12px -6px rgba(0, 0, 0, 0.75);
  box-shadow: -3px 2px 12px -6px rgba(0, 0, 0, 0.75);
  @media screen and (max-width: 950px) {
    min-height: 0;
  }
  @media screen and (max-width: 650px) {
    padding: 2rem 0rem;
  }
`;
const ResultText = styled.div`
  grid-column: 1/13;
  -ms-grid-column: 1;
  -ms-grid-column-span: 12;
  grid-column: 1/13;
  font-size: 20px;
  line-height: 32px;
  text-align: left;
  min-height: 1.4rem;
  color: #232a36;
  font-weight: bold;
  @media screen and (max-width: 640px) {
    font-size: 16px;
    line-height: 26px;
  }
`;

const WrapperResultTitle = styled.div`
  display: flex;
`;

const WrapperResultNumber = styled.div`
  display: flex;
  font-size: 20px;
  line-height: 32px;
  margin-left: 40px;
  font-weight: 300;
  text-align: left;
  @media screen and (max-width: 640px) {
    font-size: 16px;
    line-height: 26px;
  }
`;

const ResultNumber = styled.div`
  margin-right: 12px;
`;

const Einsparpotenzial = styled.div`
  font-size: 28px;
  line-height: 40px;
  color: #232a36;
  text-align: left;
  margin-left: 36px;
  font-weight: bold;
  @media screen and (max-width: 640px) {
    font-size: 20px;
    line-height: 26px;
  }
`;

const Subtitle = styled(Einsparpotenzial)`
  font-size: 20px;
  line-height: 32px;
  font-weight: normal;
  @media screen and (max-width: 640px) {
    font-size: 16px;
    line-height: 26px;
  }
`;

const Unit = styled.div``;

class Result extends Component {
  render() {
    return (
      <FooterContainer>
        <Footer>
          <WhiteContainer>
            <WhiteContainerInner>
              <Einsparpotenzial>Ihr Einsparpotenzial</Einsparpotenzial>
              <Subtitle>
                bei {this.props.rechercheAufwand} Recherchestunden pro Monat
              </Subtitle>
              <ResultBox>
                <ResultMini>
                  <WrapperResultTitle>
                    <img className="iconResult" src={iconClock} alt="clock" />
                    <ResultText>Zeitersparnis:</ResultText>
                  </WrapperResultTitle>
                  <WrapperResultNumber>
                    <ResultNumber>
                      {new Intl.NumberFormat("de-DE", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(this.props.zeitersparnisProMonat)}
                    </ResultNumber>
                    <Unit>Stunden pro Monat</Unit>
                  </WrapperResultNumber>
                  <WrapperResultNumber>
                    <ResultNumber>
                      {new Intl.NumberFormat("de-DE", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(this.props.zeitersparnisProJahr)}
                    </ResultNumber>
                    <Unit>Stunden pro Jahr</Unit>
                  </WrapperResultNumber>
                </ResultMini>
                <ResultMini>
                  <WrapperResultTitle>
                    <img
                      className="iconResult"
                      src={iconInvoice}
                      alt="invoice"
                    />
                    <ResultText>Einsparpotenzial:</ResultText>
                  </WrapperResultTitle>
                  <WrapperResultNumber>
                    <ResultNumber>
                      {new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(this.props.einsparpotenzialProMonat)}
                    </ResultNumber>
                    <Unit> pro Monat</Unit>
                  </WrapperResultNumber>
                  <WrapperResultNumber>
                    <ResultNumber>
                      {new Intl.NumberFormat("de-DE", {
                        style: "currency",
                        currency: "EUR",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(this.props.einsparpotenzialProJahr)}
                    </ResultNumber>
                    <Unit> pro Jahr</Unit>
                  </WrapperResultNumber>
                </ResultMini>
              </ResultBox>
              <div>
                <a href={pdf} target="_blank" rel="noreferrer">
                  Grundannahmen für die Berechnung
                </a>
              </div>
            </WhiteContainerInner>
          </WhiteContainer>
        </Footer>
      </FooterContainer>
    );
  }
}

export default Result;
